import { Component, forwardRef, Input } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { ORGANISATION_ROLES } from '@careapp/core';

import { ConstantSelector } from '../constant-selector.component';

@Component({
  selector: 'ca-role-select',
  templateUrl: './role-select.component.html',
  styleUrls: ['./role-select.component.scss'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => RoleSelectComponent), multi: true }
  ]
})
export class RoleSelectComponent extends ConstantSelector {
  formControl: FormControl = new FormControl('', [Validators.required]);
  protected _defaultOptions = ORGANISATION_ROLES;

  @Input() placeholder;
  @Input() options: string[] = this._defaultOptions;
}
